import { connect } from 'react-redux'
import {
  setAvailableFinanceTags,
  setFinanceTags,
  createNewFinanceTag,
  resetCreateFinanceTagStatusMessages,
  types,
} from '../../../../actions/projects/form_actions'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.CREATE_NEW_FINANCE_TAG])

export default connect(
  (state: any) => ({
    availableFinanceTags: state.projects?.form?.availableFinanceTags || [],
    financeTags: state.projects?.form?.financeTags || [],
    isFetching: loadingSelector(state),
    createFinanceTagError: state.projects?.form?.createFinanceTag?.error,
    createFinanceTagSuccess: state.projects?.form?.createFinanceTag?.success,
  }),
  {
    setAvailableFinanceTags,
    setFinanceTags,
    createNewFinanceTag,
    resetCreateFinanceTagStatusMessages,
  }
)
